<section class="h-full flex flex-col gap-2 z-0 relative overflow-y-auto  p-2 lg:pl-0">
  <div class="max-w-6xl p-4 rounded-lg bg-white dark:bg-zinc-950 border" [ngClass]="{
            'shadow-lg border border-zinc-950/10 dark:border-white/10': source !== 'modal'
          }">
    <form [formGroup]="modifierCodeForm" (ngSubmit)="onSubmit()">
      <h1 *ngIf="source !== 'modal'" class="heading">
        {{modifierCodeId ? 'Edit' : 'Add'}}
      </h1>
      <hr *ngIf="source !== 'modal'" class="my-4 mt-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
      <section class="grid gap-4 sm:grid-cols-2">
        <div class="space-y-1">
          <label class="subheading">
            Title <span class="text-red-600">*</span>
          </label>
          <div>
            <div>
              <input formControlName="title" type="text" />
            </div>
            <div *ngIf="submitted && form.title.errors">
              <p *ngIf="form.title.errors.required" class="pt-1 text-red-600 text-xs">
                Title is required
              </p>
            </div>
          </div>
        </div>
        <div class="space-y-1">
          <label class="subheading">
            Code <span class="text-red-600">*</span>
          </label>
          <div>
            <div>
              <input formControlName="code" type="text" />
            </div>
            <div *ngIf="submitted && form.code.errors">
              <p *ngIf="form.code.errors.required" class="pt-1 text-red-600 text-xs">
                Code is required
              </p>
            </div>
          </div>
        </div>
        <div class="space-y-1">
          <label class="subheading">
            Status
          </label>
          <div>
            <div>
              <select formControlName="isActive">
                <option [value]="true">Active</option>
                <option [value]="false">Inactive</option>
              </select>
            </div>
            <div *ngIf="submitted && form.isActive.errors">
              <p *ngIf="form.isActive.errors.required" class="pt-1 text-red-600 text-xs">
                Status is required
              </p>
            </div>
          </div>
        </div>
      </section>
      <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
      <section class="flex justify-end gap-4">
        <button type="submit" class="btn btn-secondary">
          {{modifierCodeId ? 'Update' : 'Create'}}
        </button>
      </section>
    </form>
  </div>

</section>